import { sleep } from "@/shared/utils";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { api } from "@/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Proveedor } from "@/shared/types/proveedor";

export interface ProveedorAddRequest {
    nombre: string,
    numDocumento: string,
    email?: string,
    telefono?: string,
    direccion?: string,
}

export async function addProveedor(request: ProveedorAddRequest): Promise<Proveedor> {
    await sleep(1000);
    const response = await api.post("proveedores", request);
    return response.data;
}

export function useAddProveedorMutation(mutationConfig: MutationConfig<Proveedor, ProveedorAddRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: addProveedor,
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["proveedores"] });
        },
    })
}

export interface AddProveedorMutationProps {
    mutationConfig?: MutationConfig<Proveedor, ProveedorAddRequest>
    children?: (mutationResult: MutationResult<Proveedor, ProveedorAddRequest>) => ReactNode
}

export function AddProveedorMutation({
    mutationConfig,
    children
}: AddProveedorMutationProps) {
    const mutationResult = useAddProveedorMutation(mutationConfig);
    return children && children(mutationResult);
}